import type { FaireProductEntity } from "../../entity_types/product";

export const p_qmzq9x6yd6: FaireProductEntity = {
  token: "p_qmzq9x6yd6",
  type: "product",
  name: "Long cashmere scarf fall - Orice",
  brandToken: "b_ufufbh5wqc",
  brandName: "Orice",
  imageUrl:
    "https://cdn.faire.com/fastly/702e8642ea65eacb6910a6d4a6d947d7f94784ec41762f894633070c9b53eb52.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8a7a724a033bf235ee3dccd346ace43a2a5e6ab509d91709ced7dca28857df5e.jpeg",
    "https://cdn.faire.com/fastly/44182b228b3c0d095e3ab7da23c6d4f0180301d7a8fd961e916646f5e36e2465.jpeg",
    "https://cdn.faire.com/fastly/9d67e1e24ae96b3e0d721c8aa76c23ced3dd27438b79ef80cb8bb4f8eeb27d37.jpeg",
    "https://cdn.faire.com/fastly/4bd3f8744e96b72107761c5b7ac400906fe3d33a1d81ccd4b36b6ef33d75cd35.jpeg",
    "https://cdn.faire.com/fastly/b43641e87568bd4f532210e44fe24502b643cb6fe6cfba5c8a571d3f18f1015a.jpeg",
    "https://cdn.faire.com/fastly/08522e6b629eef90294cdb6bb2949283b91aa0aa0b3ab7287dfc4f2132c5a184.jpeg",
    "https://cdn.faire.com/fastly/170ab6a063386ffaf9a57721942497c41b91a1b9d0ce159cd2c248209348be21.jpeg",
    "https://cdn.faire.com/fastly/bf3ee3e7ab50b3ea4266c9f2b1137de1234999b0fff969d12144f84310c80416.jpeg",
    "https://cdn.faire.com/fastly/9d0a79ca1b83ffd94b62f8a447f2d10fc202eca3bdb9b664744066348f5821b4.jpeg",
    "https://cdn.faire.com/fastly/9cd1420eab2f34fe400acbd2b553f29bc5cb7bceeb6e267fa29d969ff3a38655.jpeg",
    "https://cdn.faire.com/fastly/4381a1cd35be3e87195800a7c13370ea410f1b29db2d8d764889ef4511186a3c.jpeg",
    "https://cdn.faire.com/fastly/56cce61dd09bce48108ad6608b17f019a95aa9140b246cedab4fff1f4c392e3d.jpeg",
    "https://cdn.faire.com/fastly/e22d551a07db04e7f87f6651cc9724cc6682dc92f07a90219efcb11d52d86a7a.jpeg",
    "https://cdn.faire.com/fastly/c61ab8a002993b09878b17cb324b7c7f81c80e5bee8a8789a4c48ee55dbc3982.jpeg",
    "https://cdn.faire.com/fastly/2144d6453d89adca4a72fa785d4654c2cd693bae791ddbc0a3ca652aa81f260f.jpeg",
    "https://cdn.faire.com/fastly/75e349f51f1d7aa852c6ff4e7605969115e37d70565de72064fd94e53c4ab8ed.jpeg",
    "https://cdn.faire.com/fastly/12ad8fae4453800734f26a2af3dc446103601d934c94145fac12b9a2cdc8a309.jpeg",
    "https://cdn.faire.com/fastly/be5f1421044288e1ad0a83afd36b38a2d912873621b93529113e8ca321214ac9.jpeg",
    "https://cdn.faire.com/fastly/eb5c9e92c835645dfa5b93c0b1953c504544a35fca287b4ece304aeceb59def5.jpeg",
    "https://cdn.faire.com/fastly/c342a5cb2d349520bf5c5d347f7d002200c989d92ac285b6cc9ca54b9382461e.jpeg",
    "https://cdn.faire.com/fastly/9b6d2ce4d46b29761e7813c229fc6071dd4dfcb93ea5c067a1d29d4e00ced786.jpeg",
    "https://cdn.faire.com/fastly/fc4571bb55808dc4f301d5906d85e759a842e2308dd8dba5777332e8ebcd0030.jpeg",
    "https://cdn.faire.com/fastly/ec6d7da8dccb7670feb374bcca3ddcd44977a72b863bd6a6fbbf69d3867cf36d.jpeg",
    "https://cdn.faire.com/fastly/538ba2ccd84fe5fa254cff1d8de1523c38617f23098f3b306bca894dccc0bd91.jpeg",
    "https://cdn.faire.com/fastly/c8822af89a11013ceb2f16ec63b30c06b4850564281bfdf8c2be94ccb4f1ede1.jpeg",
    "https://cdn.faire.com/fastly/fc55cbc5a5a3171190d505bf72b05f2ccb8cc3525b2dba6f062548de7b79ef8d.jpeg",
    "https://cdn.faire.com/fastly/7cd08009e99f0bc5107a50c14656faff06f05cfc039b540de234c4d53ee90063.jpeg",
    "https://cdn.faire.com/fastly/83a2f365e2ce57ca3a7d6c7c3705dac64554d923628ada649d30664448c225c0.jpeg",
    "https://cdn.faire.com/fastly/1d908a95860bcdaab317f3ad8b1202588d66ccdf5968acc37eb15a42760bc7a7.jpeg",
    "https://cdn.faire.com/fastly/776f3fb65cae94296bf03e59bd1e0e0e5e7fac7206eac53a325cb408cb8c3b25.jpeg",
  ],
  priceDollars: 25.15,
  description:
    "Long cashmere scarf, crafted from cashmere and wool knit. It offers a soft touch and measures 60 x 190 cm.",
  tags: [],
  msrpDollars: 50.29,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T17:55:55.235Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
